var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    fill: "none",
    viewBox: "0 0 20 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 11.49q.564 0 1.027-.452l8.59-8.792q.19-.18.293-.406.09-.238.09-.508a1.37 1.37 0 0 0-.17-.677 1.3 1.3 0 0 0-.473-.474A1.25 1.25 0 0 0 18.69 0a1.3 1.3 0 0 0-.948.406l-8.296 8.5h1.095L2.257.405A1.3 1.3 0 0 0 1.31 0Q.937 0 .643.18.35.35.181.656 0 .96 0 1.332q0 .53.384.914l8.589 8.792q.214.226.474.339t.553.113"
  })));
};
export default SvgArrowDown;